var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBingxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6948_102097)",
    filter: "url(#filter0_d_6948_102097)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 49.405,
    rx: 40,
    ry: 39.9988,
    fill: "#0848FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6948_102097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2849 43.4984C33.2003 43.4984 33.9465 42.7522 33.9465 41.8368C33.9465 40.9214 33.2003 40.1753 32.2849 40.1753C31.3695 40.1753 30.6234 40.9214 30.6234 41.8368C30.6234 42.7522 31.3695 43.4984 32.2849 43.4984ZM28.5849 46.0014C28.6188 46.8796 28.3118 47.7368 27.728 48.3938V48.4014C28.1865 48.7114 29.3234 49.5607 29.3234 51.193C29.3234 53.0607 27.7949 54.5822 25.9188 54.5822H16.7695V42.7676H25.1065C26.938 42.7676 28.4965 44.1845 28.5849 46.0014ZM25.6234 46.2376C25.6234 45.4107 24.9372 45.0414 24.1541 45.0414H19.7234V47.3968H24.1541C24.9218 47.3968 25.6157 47.0576 25.6234 46.2376ZM19.708 49.6714L19.7234 52.3076V52.2999H24.8926C25.6534 52.2999 26.3541 51.8053 26.3695 50.9861C26.3695 50.1591 25.6757 49.6714 24.8926 49.6714H19.708ZM30.808 44.2368H33.7618V54.5753H30.808V44.2368ZM46.6772 49.0884C46.6772 46.3853 44.8311 44.6653 42.6157 44.3038C42.3319 44.2617 42.0456 44.2393 41.7588 44.2368C40.8065 44.2368 39.6765 44.4138 38.5541 44.9753V44.2368H35.6003V54.5753H38.5541V49.3907C38.5541 47.3161 39.7649 46.5699 41.1388 46.5699C42.6157 46.5699 43.7234 47.5453 43.7234 49.3914V54.5753H46.6772V49.0884ZM67.9672 46.5038C65.6634 43.9853 62.7234 43.4984 61.0849 43.4984V46.563C62.2957 46.563 64.4818 46.9399 66.0842 49.0291C64.4818 51.1191 62.2957 51.4961 61.0842 51.4961V54.5599C62.7242 54.5599 65.6634 54.0722 67.9672 51.5538C70.3518 54.0868 73.0695 54.5599 74.768 54.5599V51.4953C73.6088 51.4953 71.6149 51.1999 69.828 49.0284C71.6149 46.8576 73.6165 46.5622 74.768 46.5622V43.4984C73.0695 43.4984 70.3526 43.9707 67.9672 46.5038ZM56.6465 44.9976V44.2361H59.5926V53.313C59.5926 54.9668 58.7434 58.6361 53.5303 58.6361C50.9157 58.6361 48.7595 57.5591 47.7772 56.0591L49.9926 54.5745C50.4357 55.1807 51.6026 56.0514 53.3157 56.0514C56.0188 56.0514 56.6388 54.1914 56.6388 53.313C55.8265 53.8884 54.6895 54.2053 53.2272 54.2053C50.3988 54.2053 47.7849 51.8945 47.7849 48.9407C47.7849 45.9868 50.4211 44.2368 53.2349 44.2368C54.9403 44.2368 56.218 44.7907 56.6465 44.9976ZM50.7388 49.0961C50.7388 50.4914 52.0603 51.6214 53.6926 51.6214C55.3242 51.6214 56.6465 50.4914 56.6465 49.0961C56.6465 47.6999 55.3242 46.5699 53.6926 46.5699C52.0603 46.5699 50.7388 47.7007 50.7388 49.0961Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6948_102097",
    x: 0.5,
    y: 0.40625,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6948_102097"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6948_102097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6948_102097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6948_102097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(5.5 9.40625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6948_102097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.4615,
    height: 18.4615,
    fill: "white",
    transform: "translate(16.7695 40.1753)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBingxIcon);
export default __webpack_public_path__ + "static/media/bingx-icon.8c9a13a7587d4916099d159bf83df6c0.svg";
export { ForwardRef as ReactComponent };